export default function isMaster({ next, store }) {
  const expert = store.getters['expert/getData'] || {};

  if (expert.isMaster === true) {
    return next();
  }

  return next({
    name: 'MainIndex'
  });
}
